import { useState, useEffect } from "react";

const KEY = "sbdb_favorites";

export function useFavorites() {
  const [favorites, setFavorites] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(favorites));
  }, [favorites]);

  const isFavorite = (title) => favorites.includes(title);
  const toggleFavorite = (title) => setFavorites((prev) =>
    prev.includes(title) ? prev.filter((t) => t !== title) : [...prev, title]
  );

  return { favorites, isFavorite, toggleFavorite };
}
